import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';

import CheckInCallChip from './Chip';

export const CheckInCallsGridColDef = () => {
    return [
        createColumnDef({
            field: 'serviceNumber',
            headerName: 'Service ID',
        }),
        createColumnDef({
            field: 'merchantName',
            headerName: 'Merchant Name',
        }),
        createColumnDef({
            field: 'callName',
            headerName: 'Call Name',
        }),
        createColumnDef({
            field: 'days',
            headerName: 'Scheduled Call',
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <>
                        <CheckInCallChip days={params.value} />
                    </>
                );
            },
        }),
    ];
};

export default CheckInCallsGridColDef;
